import client from '../client'

/**
 * Submit bug report
 * @param {object} body Bug report
 */
export const sendBugReport = (body) =>
  client.post('/dashboard/v1/bug-report', body)
